export const selectUpdateSteps = (state) => state.update.updateSteps;
export const selectUpdatedPermitData = (state) => state.update?.applicationData;
export const selectDocumentUploadStarted = (state) =>
  state.update?.documentUploadStarted;
export const selectDocumentUploadWorking = (state) =>
  state.update?.documentUploadWorking;
export const selectDocumentUploadCompleted = (state) =>
  state.update?.documentUploadCompleted;
export const selectDocumentUploadErrors = (state) =>
  state.update?.documentUploadErrors;
export const selectPermitRegistrant = (state) =>
  state.update?.applicationData?.registrant;
export const selectApplicationNumber = (state) =>
  state.update?.applicationNumber;
export const selectInitiatingUpdateFlow = (state) =>
  state.update.initiatingUpdateFlow;
export const selectInitiatingUpdateFlowError = (state) =>
  state.update.initiatingUpdateFlowError;

export const selectUpdateLicenseInProgress = (state) =>
  state.update.updateLicenseInProgress;
export const selectUpdateLicenseError = (state) =>
  state.update.updateLicenseError;
